import { type JSX } from "react";

export default function FOX(): JSX.Element {
  return (
    <svg
      aria-label="FOX Logo"
      data-testid="fox"
      role="img"
      viewBox="0 0 129 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="fox"
        fill="#000000"
        stroke="none"
        d="M 0.924194 0.065918 L 0.924194 55.039829 L 16.429905 55.039829 L 16.391558 37.266502 L 31.613083 37.266502 L 31.613083 22.269863 L 16.517488 22.269863 L 16.517488 15.096878 L 35.04644 15.096878 L 34.030128 0.065918 L 0.924194 0.065918 Z M 112.373848 26.435247 L 128.924194 54.958324 L 111.798683 54.958324 L 103.759598 41.095146 L 95.812805 54.989338 L 79.154045 54.958324 L 95.401299 26.620436 L 80.060532 0.147358 L 97.212929 0.147358 L 103.967049 11.988823 L 110.844452 0.147358 L 127.414261 0.147358 L 112.373848 26.435247 Z M 34.624805 27.624586 C 34.624805 12.861668 46.353168 0.894901 60.820442 0.894901 C 75.28772 0.894901 87.014709 12.861668 87.014709 27.624586 C 87.014709 42.386837 75.287048 54.354271 60.820442 54.354271 C 46.352482 54.354271 34.624805 42.386837 34.624805 27.624586 Z M 56.447689 38.531967 C 56.447689 41.037907 58.437725 43.069061 60.893135 43.069061 C 63.34861 43.069061 65.560219 41.101913 65.560219 38.595951 L 65.493546 16.635017 C 65.493546 14.129761 63.349297 11.887844 60.893822 11.887844 C 58.438412 11.887844 56.453064 14.129761 56.453064 16.635017 L 56.447689 38.531967 Z"
      />
    </svg>
  );
}
